import React from 'react';
import { TextField, InputAdornment } from '@mui/material';

const TextFieldComponent = ({ 
  label,
  placeholder = "Enter here",
  value,
  defaultValue,
  onChange,
  width = '372px',
  height = '42px',
  readOnly = false,
  backgroundColor = '#FFFFFF',
  className = '',
  icon = null,
  ...props 
}) => {
  return (
    <div>
      <label
        className={`block mb-2 ${className}`}
        style={{
          fontFamily: 'Inter',
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '120%',
          color: '#1F2937'
        }}
      >
        {label}
      </label>
      <TextField
        placeholder={placeholder}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        variant="outlined"
        fullWidth
        InputProps={{
          readOnly: readOnly,
          startAdornment: icon ? (
            <InputAdornment position="start" sx={{ mr: 0 }}>
              <img src={icon} alt="icon" style={{ width: 20, height: 20, marginRight: 10 }} />
            </InputAdornment>
          ) : undefined,
        }}
        sx={{
          width: width,
          height: height,
          '& .MuiOutlinedInput-root': {
            height: height,
            borderRadius: '8px',
            boxShadow: '0px 1px 2px 0px #0000000D',
            backgroundColor: backgroundColor,
            '& fieldset': {
              border: '1px solid #D1D5DB',
              borderRadius: '8px'
            },
            '&:hover fieldset': {
              borderColor: '#D1D5DB'
            },
            '&.Mui-focused fieldset': {
              borderColor: '#D1D5DB',
              borderWidth: '1px'
            }
          },
          '& .MuiInputBase-input': {
            padding: icon ? '11px 4px 11px 4px' : '11px 12px',
            fontFamily: 'Inter',
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '140%',
            letterSpacing: '-3%',
            '&::placeholder': {
              fontFamily: 'Inter',
              fontWeight: '400',
              fontSize: '14px',
              lineHeight: '140%',
              letterSpacing: '-3%',
              color: '#979797',
              opacity: 1
            }
          },
          '& .MuiInputAdornment-positionStart': {
            marginRight: 0,
          },
        }}
        {...props}
      />
    </div>
  );
};

export default TextFieldComponent;
